import { HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, LocMap } from '@cm/core/localization';

const pathStart = 'Catalogs|Credentials|ECert|';
const sharedProperties: Pick<LocDef, 'shared' | 'htmlAllowed' | 'feature' | 'portal'> = {
	shared: false,
	htmlAllowed: false,
	feature: HubFeature.Credential,
	portal: 'SP',
};

type LocNameStart = 'SPCatalogsCredentialEcert';
export type SPCatalogsCredentialEcertLocNames =
	| `${LocNameStart}TitleSection`
	| `${LocNameStart}TitleTab`
	| `${LocNameStart}ButtonCancel`
	| `${LocNameStart}ButtonEdit`
	| `${LocNameStart}ButtonUpdate`
	| `${LocNameStart}ButtonEdit`
	| `${LocNameStart}LabelCertEnabled`;

export const spCatalogsCredentialEcertLocs: LocDefs<SPCatalogsCredentialEcertLocNames> = {
	SPCatalogsCredentialEcertTitleSection: {
		defaultValue: 'eCertificate',
		description: 'Section title',
		displayPath: `${pathStart}Section title`,
		displayType: 'Title',
		legacyName: 'Credential/CatalogsCredential.Ecert.Title.SectionTitle',
		...sharedProperties,
	},
	SPCatalogsCredentialEcertTitleTab: {
		defaultValue: 'Credential eCert',
		description: 'Tab title',
		displayPath: `${pathStart}Tab title`,
		displayType: 'Title',
		legacyName: 'Credential/CatalogsCredential.Ecert.Title.TabTitle',
		...sharedProperties,
	},
	SPCatalogsCredentialEcertButtonCancel: {
		defaultValue: 'Cancel',
		description: 'Cancel button',
		displayPath: `${pathStart}Cancel`,
		displayType: 'Button',
		legacyName: 'Credential/CatalogsCredential.Ecert.Button.Cancel',
		...sharedProperties,
	},
	SPCatalogsCredentialEcertButtonEdit: {
		defaultValue: 'Edit',
		description: 'Edit button',
		displayPath: `${pathStart}Edit`,
		displayType: 'Button',
		legacyName: 'Credential/CatalogsCredential.Ecert.Button.Edit',
		...sharedProperties,
	},
	SPCatalogsCredentialEcertButtonUpdate: {
		defaultValue: 'Update',
		description: 'Update button',
		displayPath: `${pathStart}Update`,
		displayType: 'Button',
		legacyName: 'Credential/CatalogsCredential.Ecert.Button.Update',
		...sharedProperties,
	},
	SPCatalogsCredentialEcertLabelCertEnabled: {
		defaultValue: 'Certificate Downloads Enabled',
		description: 'Label for: Certificate Downloads Enabled.',
		displayPath: `${pathStart}Certificate Downloads Enabled`,
		displayType: 'Label',
		legacyName: 'Credential/CatalogsCredential.Ecert.FieldLabel.CertEnabled',
		...sharedProperties,
	},
};

export type SPCatalogsCredentialEcertLocType = LocMap<SPCatalogsCredentialEcertLocNames>;
